import { useQuery } from '@tanstack/react-query';
import { readShigoAppConfig } from '../../../../../../lib/config';
import { useShigoSession } from '../../../../../../lib/useShigoSession';
import { canReadIntegrationJourney } from '../../../../../auth/accessPolicy';
import { createJourneyClient } from './journeyApi';
import type { JourneyRequest } from './journeyFlowModel';

export function useJourneyQuery(request: JourneyRequest) {
  const { session } = useShigoSession();
  const config = readShigoAppConfig();
  const client = createJourneyClient(
    { apiBaseUrl: config.reportingServiceUrl, networkId: config.networkId },
    session?.accessToken ?? '',
  );
  return useQuery({
    staleTime: 0,
    queryKey: [
      'demand-integrations',
      'journey',
      config.reportingServiceUrl,
      config.networkId,
      session?.user,
      request,
    ],
    queryFn: () => client.run(request),
    enabled: Boolean(
      session && canReadIntegrationJourney(session.user) && request.demandIntegrationId,
    ),
  });
}
